import script from "./theNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./theNotice.vue?vue&type=script&setup=true&lang=js"

import "./theNotice.vue?vue&type=style&index=0&id=26e6acbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e6acbe"]])

export default __exports__